export default "__VITE_ASSET__D23zJUrI__"